<template>
  <div class="dashboard-card" @click="$emit('click')">
    <div class="card-preview">
      <div class="preview-row">
        <div class="preview-item" v-for="(img, index) in previewImages.slice(0, 2)" :key="index">
          <div class="preview-placeholder"></div>
        </div>
      </div>
      <div class="preview-row">
        <div class="preview-item" v-for="(img, index) in previewImages.slice(2, 4)" :key="index + 2">
          <div class="preview-placeholder"></div>
        </div>
      </div>
    </div>
    
    <div class="card-content">
      <div class="card-info">
        <h3 class="card-title">{{ dashboard.title }}</h3>
        <div class="card-stats">
          <div class="stat-item">
            <v-icon size="17" class="stat-icon">mdi-view-grid</v-icon>
            <span class="stat-text">{{ dashboard.charts }}/{{ dashboard.totalCharts }}</span>
          </div>
          <div class="stat-item" v-if="dashboard.shared">
            <v-icon size="17" class="stat-icon">mdi-earth</v-icon>
            <span class="stat-text">{{ dashboard.charts }}/{{ dashboard.totalCharts }}</span>
          </div>
        </div>
      </div>
      <button class="card-menu-btn" @click.stop="$emit('menu')">
        <v-icon size="26">mdi-dots-vertical</v-icon>
      </button>
    </div>

    <button 
      v-if="dashboard.isStarred" 
      class="star-btn" 
      @click.stop="$emit('star')"
    >
      <img :src="starIcon" alt="Star" class="star-icon" />
    </button>
  </div>
</template>

<script>
export default {
  name: "DashboardCard",
  props: {
    dashboard: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      starIcon: require("@/assets/Images/Dashboard/star.svg"),
    };
  },
  computed: {
    previewImages() {
      return this.dashboard.previewImages || [];
    },
  },
};
</script>

<style scoped>
@import '../../assets/Styling/agenticDashboard/dashboardCard.css';
</style>

